module.exports = __webpack_public_path__ + "img/thabo.3edfb7af.png";